// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"seniorityFilter_checkboxContainer__wHEGT"};